import { render, staticRenderFns } from "./search_page_help.vue?vue&type=template&id=450d0c89&scoped=true&"
import script from "./search_page_help.vue?vue&type=script&lang=js&"
export * from "./search_page_help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d0c89",
  null
  
)

export default component.exports